export default __webpack_public_path__ + "static/media/sidebar-12.3756b71c.jpg";